import { commonShared } from 'com-ui/utilities/imagePath'
import css from 'styled-jsx/css'

export const SignUpLayout = ({ children }: any) => {
  return (
    <div className="layout">
      <div className="logo-container">
        <img src={commonShared('selless-logo-black.svg')} alt="selless logo" />
      </div>
      {children}
      <style jsx>{style}</style>
    </div>
  )
}

const style = css`
  .layout {
    min-height: 100vh;
    background-color: var(--indigo-2);
    padding: 64px 16px;
  }
  .logo-container {
    padding: 0 0 32px;
    text-align: center;
  }
`
